exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form-panel {\n  display: flex;\n  align-items: center;\n  width: 357px;\n  height: 581px;\n}\n.login-form-panel__label {\n  margin-bottom: 80px;\n  font-size: 30px;\n  color: #555;\n}\n.login-form-panel__content {\n  width: 100%;\n}\n.login-form__submit {\n  display: flex;\n  justify-content: center;\n  margin-top: 80px;\n}\n.login-form__error {\n  font-size: 16px;\n  color: #f0506e;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Login/components/LoginForm/LoginForm.less
// module id = 1057
// module chunks = 0